import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Towers } from '@genomawork/genoma-games';
import '../App.css';
import { SERVER_URL } from '../AppRouter';

const ANTD4_CSS_HREF = '/antd4.min.css';
const ANTD4_CSS_ID = 'antd4-towers-css';

function TowersGameDemo() {
    const [showGame, setShowGame] = useState(false);
    const [cssReady, setCssReady] = useState(false);
    const queryString = new URLSearchParams(window.location.search);
    const navigate = useNavigate();
    const token = queryString.get("token") || null;
    const language = queryString.get("lang") || 'es';
    const callback = queryString.get("callback") || null;

    useEffect(() => {
        let link = document.getElementById(ANTD4_CSS_ID) as HTMLLinkElement | null;
        if (link) {
            setCssReady(true);
        } else {
            link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = ANTD4_CSS_HREF;
            link.id = ANTD4_CSS_ID;
            link.onload = () => setCssReady(true);
            link.onerror = () => setCssReady(true);
            document.head.appendChild(link);
        }
        return () => {
            document.getElementById(ANTD4_CSS_ID)?.remove();
        };
    }, []);

    useEffect(() => {
        if (!token) {
        navigate("/notFound");
        return;
        }
        axios({
        method: 'get',
        url: `${SERVER_URL}?path=demo&token=${token}`,
        withCredentials: false,
        }).then((response) => {
        if (response.status < 400) {
            if (response.data['newRoute'] === 'feedback') {
                setShowGame(false);
                if (callback) {
                    window.location.href = callback + `?token=${token}&lang=${language}`;
                    return; // Ensure the function exits after redirecting
                }
                navigate(`/towers/feedback?${queryString.toString()}`);
            } else {
            setShowGame(true);
            }
        }
        }).catch(() => {
        navigate("/notFound");
        });
    }, []);

    function postData(allData: any) {
        const submit = JSON.stringify({ game_code: 'TOW2', game_outcome: allData });
        return axios({
            method: 'post',
            url: `${SERVER_URL}?path=demo&token=${token}`,
            withCredentials: false,
            data: submit,
            headers: { 'Content-Type': 'application/json' },
        }).then((response) => {
            if (response.status < 400) {
            setShowGame(false);
            if (callback) {
                window.location.href = callback + `?token=${token}&lang=${language}`;
                return; // Ensure the function exits after redirecting
            }
            navigate(`/towers/feedback?${queryString.toString()}`);
            } else {
            setShowGame(true);
            }
        }).catch(() => {
            setShowGame(false);
            navigate(`/towers/feedback?${queryString.toString()}`);
        });
    }

    return (
        <div className="protected full-height">
        {showGame && <Towers
            goBack={() => console.log("Back")}
            onSubmit={postData}
            language={language}
            callBack={() => console.log("Call back")}
            maxStages={5}
            noTest
        />}
        </div>
    );
}

export default TowersGameDemo;